import { Button, Stack, Typography } from "@mui/material";
import Appbar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import React, { useState } from "react";
import LoginDialog from "./Common/LoginDialog";
import { useSelector } from "react-redux";
import GetInTouch from "./Common/GetInTouch";

const LogoSection = () => {
  return (
    <Stack
      direction="row"
      spacing={{ xs: 1, md: 1.5 }}
      alignItems="center"
      justifyContent="center"
    >
      <img
        src="/assets/icons/LZ-logo-face.svg"
        alt="logo face"
        style={{ marginBottom: "2px" }}
      />

      <img
        src="/assets/icons/LZ-logo.svg"
        alt="logo"
        style={{ marginTop: "4px" }}
      />
    </Stack>
  );
};
const PortalButtons = ({ handlePortalButtonClick, isStacked, isMobile }) => {
  return (
    <Stack
      direction={isStacked ? "column" : "row"}
      spacing={isStacked ? 1.5 : 2}
      alignItems="center"
      sx={{ width: isStacked ? "100%" : "auto" }}
    >
      <Button
        variant="text"
        sx={{
          "&:hover": { backgroundColor: "transparent" },
          textTransform: "none",
          width: isMobile ? "100%" : "auto",
          justifyContent: "center",
        }}
        disableRipple
        onClick={() => handlePortalButtonClick("transporter")}
        fullWidth={isMobile}
      >
        <Typography
          color="#333333"
          sx={{ textDecoration: "underline", fontWeight: "bold" }}
        >
          LoadEazy Partner
        </Typography>
      </Button>
      <Button
        variant="contained"
        sx={{
          fontWeight: "bold",
          backgroundColor: "#0C7F44",
          textTransform: "none",
          width: isMobile ? "100%" : "auto",
          justifyContent: "center",
          "&:hover": { backgroundColor: "#0A6B39" },
        }}
        startIcon={
          <img
            src="/assets/icons/login-button-icon.svg"
            alt="login"
            style={{ width: "1.125rem" }}
          />
        }
        onClick={() => handlePortalButtonClick("customer")}
        fullWidth={isMobile}
      >
        Login
      </Button>
    </Stack>
  );
};
const GetInTouchSection = ({ isStacked }) => {
  const number = useSelector((state) => state.supportNumbers?.landingPage);
  return (
    <Stack
      spacing={0.75}
      alignItems={isStacked ? "center" : "flex-end"}
      textAlign={isStacked ? "center" : "right"}
      sx={{ width: isStacked ? "100%" : "auto" }}
    >
      <GetInTouch />
      <Typography
        variant="p"
        color="#0C7F44"
        fontWeight={700}
        sx={{ display: "block" }}
      >
        {number}
      </Typography>
    </Stack>
  );
};

const Navbar = () => {
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [stakeholder, setStakeholder] = useState(null);
  const theme = useTheme();
  const isMediumDown = useMediaQuery(theme.breakpoints.down("md"));
  const isSmallDown = useMediaQuery(theme.breakpoints.down("sm"));
  /**
   * helps in picking which portal user wants to enter
   * @param {customer,partner} clickedPortal
   */
  const handlePortalButtonClick = (clickedPortal) => {
    setStakeholder(clickedPortal);
    setIsLoginModalOpen(true);
  };
  // this function closes login modal upon clicking cross mark
  const handleCloseLoginModal = () => {
    setIsLoginModalOpen(false);
  };
  return (
    <Box maxWidth="xl" sx={{ margin: "auto" }}>
      <Appbar
        position="static"
        sx={{ background: "#FFF", margin: "auto", boxShadow: "none" }}
        id="landing-page-navbar"
      >
        <Box
          px={{ xs: 2.5, sm: 4, md: 6, lg: 12, xl: 16 }}
          py={{ xs: 1.25, sm: 1.5, md: 1.75, lg: 2.5, xl: 4 }}
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: { xs: "center", md: "space-between" },
            alignItems: { xs: "stretch", md: "center" },
            gap: { xs: 2, sm: 2.5, md: 0 },
          }}
        >
          <Box sx={{ display: "flex", justifyContent: { xs: "center", md: "flex-start" } }}>
            <LogoSection />
          </Box>

          <Stack
            direction={isMediumDown ? "column" : "row"}
            alignItems={isMediumDown ? "stretch" : "center"}
            spacing={{ xs: 2, sm: 3, md: 6, lg: 8 }}
            sx={{ width: isMediumDown ? "100%" : "auto" }}
          >
            <PortalButtons
              handlePortalButtonClick={handlePortalButtonClick}
              isStacked={isMediumDown}
              isMobile={isSmallDown}
            />
            <GetInTouchSection isStacked={isMediumDown} />
          </Stack>
        </Box>
      </Appbar>
      <LoginDialog
        isLoginModalOpen={isLoginModalOpen}
        handleCloseLoginModal={handleCloseLoginModal}
        stakeholder={stakeholder}
      />
    </Box>
  );
};

export default Navbar;
